import React from 'react';
import { motion } from 'framer-motion';
export function Intro() {
  return <section className="py-20 bg-white" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-174">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-175">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 font-heading" data-id="element-176">
              Modernize with Confidence
            </h2>
            <div className="space-y-6 text-lg text-slate-600" data-id="element-177">
              <p data-id="element-178">
                BetterCode is an AI-powered engineering transformation
                initiative that combines tools, processes, and people to
                modernize software systems and accelerate delivery.
              </p>
              <p data-id="element-179">
                We help organizations execute migrations, conversions, upgrades,
                and continuous improvements with speed, quality, and
                predictability.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative h-64 md:h-full min-h-[300px] rounded-2xl overflow-hidden shadow-lg" data-id="element-180">
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Team collaborating on software modernization" className="absolute inset-0 w-full h-full object-cover" data-id="element-181" />
            <div className="absolute inset-0 bg-brand-navy/10 mix-blend-multiply" data-id="element-182" />
          </motion.div>
        </div>
      </div>
    </section>;
}